import React, { Component } from 'react';
import {
  Divider,
  Switch,
  Button,
  NumericInput,
  FormGroup,
} from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Jobs extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      JobPenalty: true,
      JobGuildNames: true,
      JobTrace: true,
      JobbingTrace: true,
      JobPHBot: true,
      JobBerserk: true,
      JobResScroll: true,
      JobReverseScroll: true,
      JobNPCThieves: true,
      JobTeleportDelay: 0,
      JobPCLimit: true,
      JobPCLimitCount: '',
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    const SwitchOnOff = { innerLabelChecked: 'on', innerLabel: 'off' };

    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          Jobs Settings
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td style={{ minWidth: '210px' }}>Job Penalty</td>
              <td>
                <Switch
                  checked={this.state.JobPenalty}
                  {...SwitchOnOff}
                  onChange={this.handleChange('JobPenalty')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="on Job" className="mb-0">
                  Show Guild Names
                </FormGroup>
              </td>
              <td>
                <Switch
                  checked={this.state.JobGuildNames}
                  {...SwitchOnOff}
                  onChange={this.handleChange('JobGuildNames')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="on Job Suit" className="mb-0">
                  Trace
                </FormGroup>
              </td>
              <td>
                <Switch
                  checked={this.state.JobTrace}
                  {...SwitchOnOff}
                  onChange={this.handleChange('JobTrace')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="on Jobbing" className="mb-0">
                  Trace
                </FormGroup>
              </td>
              <td>
                <Switch
                  checked={this.state.JobbingTrace}
                  {...SwitchOnOff}
                  onChange={this.handleChange('JobbingTrace')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="on Job" className="mb-0">
                  PH Bot
                </FormGroup>
              </td>
              <td>
                <Switch
                  checked={this.state.JobPHBot}
                  {...SwitchOnOff}
                  onChange={this.handleChange('JobPHBot')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="on Job" className="mb-0">
                  Berserk
                </FormGroup>
              </td>
              <td>
                <Switch
                  checked={this.state.JobBerserk}
                  {...SwitchOnOff}
                  onChange={this.handleChange('JobBerserk')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="on Jobbing" className="mb-0">
                  Resurrection Scroll
                </FormGroup>
              </td>
              <td>
                <Switch
                  checked={this.state.JobResScroll}
                  {...SwitchOnOff}
                  onChange={this.handleChange('JobResScroll')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="on Jobbing" className="mb-0">
                  Reverse Scroll
                </FormGroup>
              </td>
              <td>
                <Switch
                  checked={this.state.JobReverseScroll}
                  {...SwitchOnOff}
                  onChange={this.handleChange('JobReverseScroll')}
                />
              </td>
            </tr>

            <tr>
              <td>NPC Thief/Hunter Mob Spawn</td>
              <td>
                <Switch
                  checked={this.state.JobNPCThieves}
                  {...SwitchOnOff}
                  onChange={this.handleChange('JobNPCThieves')}
                />
              </td>
            </tr>

            <tr>
              <td>Teleport Delay</td>
              <td>
                <FormGroup
                  helperText="1000 = 1 seconds, 0 for no waiting per teleport"
                  className="mb-0"
                  style={{ width: '320px' }}
                >
                  <NumericInput
                    style={{ width: '160px' }}
                    value={this.state.JobTeleportDelay}
                    placeholder="Type milliseconds..."
                    onValueChange={this.handleChange('JobTeleportDelay')}
                    min={0}
                  />
                </FormGroup>
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="on Job" className="mb-0">
                  PC Limit
                </FormGroup>
              </td>
              <td>
                <Switch
                  checked={this.state.JobPCLimit}
                  {...SwitchOnOff}
                  onChange={this.handleChange('JobPCLimit')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="on Job" className="mb-0">
                  PC Limit Count
                </FormGroup>
              </td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  disabled={!this.state.JobPCLimit}
                  style={{ width: '190px' }}
                  value={this.state.JobPCLimitCount}
                  placeholder="Type a number..."
                  onValueChange={this.handleChange('JobPCLimitCount')}
                  min={0}
                  className="mb-4"
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
